import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

export const InputField = ({ id, label, type, value, onChange, required, placeholder }) => (
    <div>
      <label htmlFor={id} className="block text-sm font-semibold text-gray-900 dark:text-slate-200 mb-2">
        {label}
      </label>
      <input
        type={type}
        id={id}
        name={id}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className="w-full px-4 py-3 border border-gray-300 dark:border-slate-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:border-blue-500 transition-all duration-200 text-gray-900 dark:text-white bg-white dark:bg-slate-700 placeholder-gray-500 dark:placeholder-slate-400"
        required={required}
      />
    </div>
  );
  
export const PasswordField = ({ id, label, value, onChange, showPassword, toggleShowPassword, required }) => (
    <div>
      <label htmlFor={id} className="block text-sm font-semibold text-gray-900 dark:text-slate-200 mb-2">
        {label}
      </label>
      <div className="relative">
        <input
          type={showPassword ? "text" : "password"}
          id={id}
          name={id}
          value={value}
          onChange={onChange}
          className="w-full px-4 py-3 border border-gray-300 dark:border-slate-600 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:focus:border-blue-500 transition-all duration-200 text-gray-900 dark:text-white bg-white dark:bg-slate-700 placeholder-gray-500 dark:placeholder-slate-400"
          required={required}
        />
        <button
          type="button"
          className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-500 dark:text-slate-400 dark:hover:text-slate-300 transition-colors duration-200"
          onClick={toggleShowPassword}
        >
          {showPassword ? (
            <EyeSlashIcon className="h-5 w-5" aria-hidden="true" />
          ) : (
            <EyeIcon className="h-5 w-5" aria-hidden="true" />
          )}
        </button>
      </div>
    </div>
  );
